/**
 * One typed client per backend service. Paths are the service's own
 * (`/v2/...`); the prefix that routes to the service is the client's base.
 *
 *   const { data } = await unwrap(orderApi.GET("/v2/admin/orders", { params: { query } }));
 *
 * Types come from each service's openapi.json: `pnpm gen:api`.
 */
import type { paths as AuditPaths } from "./audit.schema";
import type { paths as AuthPaths } from "./auth.schema";
import type { paths as BillingPaths } from "./billing.schema";
import type { paths as ContentPaths } from "./content.schema";
import { createServiceClient } from "./http";
import type { paths as NotifyPaths } from "./notify.schema";
import type { paths as OrderPaths } from "./order.schema";
import type { paths as RealtimePaths } from "./realtime.schema";

export const authApi = createServiceClient<AuthPaths>("auth", { bearer: true });
export const orderApi = createServiceClient<OrderPaths>("order", { bearer: true });
export const billingApi = createServiceClient<BillingPaths>("billing", { bearer: true });
export const notifyApi = createServiceClient<NotifyPaths>("notify", { bearer: true });
export const realtimeApi = createServiceClient<RealtimePaths>("realtime", { bearer: true });
export const contentApi = createServiceClient<ContentPaths>("content", { bearer: true });
export const auditApi = createServiceClient<AuditPaths>("audit", { bearer: true });

/**
 * hg-auth's sign-in and sign-out endpoints. They take no bearer token, and a
 * `401` from them (`invalid_credentials`) must never start a refresh.
 */
export const authPublicApi = createServiceClient<AuthPaths>("auth", { bearer: false });

export { unwrap } from "./http";
